<!-- Blocco 1 -->
<div class="container-fluid accordion-container">
  <div class="container">
    <mat-accordion class="accordion" multi>

      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span class="index">1 </span>
            {{ 'pages.task-management.component.assigned-actions' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        @if (filters?.section_filtered?.length) {
          <div class="row">
            <div class="col-12 col-lg-6 px-0 mb-0">
              <div class="box py-0 px-2 bg-transparent border-0 mb-0">
                <mat-label class="box-title px-3 mb-0">{{ 'generic.filters' | translate }}</mat-label>
              </div>
            </div>
          </div>
          <div class="row d-flex justify-content-center">
            <mat-form-field class="select-primary col-12" appearance="fill">
              <mat-label>{{ 'generic.section-filter' | translate }}</mat-label>
              <mat-select name="filter_section" [(ngModel)]="filters.section_selected"
                (selectionChange)="filterOnChange()">
                <mat-option value="" selected></mat-option>
                @for (sec of filters.section_filtered; track sec) {
                  <mat-option [value]="sec">{{ sec }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }


        <!-- Pulsante di aggiunta Task -->
        @if (decisionPlan?.id && !createTaskActive) {
          <div class="container p-4">
            <div class="row">
              <button class="col-12 big-button" mat-raised-button (click)="addTask()">
                <i class="icon-big_add"></i>
                {{ 'components.management-plan.add-task' | translate }}
              </button>
            </div>
          </div>
        }

        @for (task of tasksToComplete; track task; let i = $index) {
          @if (task.show && task.show == true) {
            <div class="row">
              <div class="col-12 px-2">
                <div class="box px-0 box-two-row py-3" [class]="task.editMode == true ? 'border-modify': ''">
                  @if (!task.editMode) {
                    <mat-label class="box-title px-3">
                      @if (isAlexion()) {
                        {{ "pages.task-management." + task.additional_text | translate}}
                        @if (task.additional_text == 'therapy') {
                          - {{ "pages.task-management." + task.customs.therapy_type | translate}}
                        } @else {
                          - {{ "generic.session" | translate}} {{ task.customs.session.evaluation_session }}
                        }
                      } @else {
                        {{ task.additional_text }}
                      }
                    </mat-label>
                  }
                  @if (task.editMode) {
                    <mat-form-field class="pb-2 mx-2 select-primary col-12" appearance="fill">
                      @if (!isAlexion()) {
                        <mat-label>{{ 'generic.level' | translate }}</mat-label>
                      }
                      @if (isAlexion()) {
                        <mat-label>{{ 'generic.type' | translate }}</mat-label>
                      }
                      <mat-select name="task_additional_text_{{task.id}}" [(ngModel)]="task.additional_text" required>
                        @for (option of additional_text_options; track option) {
                          <mat-option [value]="option.value">{{ option.label }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                  @if (isAlexion() && task.additional_text === 'visit') {
                    @if (task.editMode) {
                      <mat-form-field class="pb-2 mx-2 select-primary col-12" appearance="fill">
                        <mat-label>{{ 'generic.session' | translate }}</mat-label>
                        <mat-select name="task_session_{{task.id}}" [(ngModel)]="task.customs.session" required>
                          @for (option of sessions_option; track option) {
                            <mat-option [value]="option.value">{{ option.label }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                  }
                  @if (isAlexion() && task.additional_text === 'therapy') {
                    @if (task.editMode) {
                      <mat-form-field class="pb-2 mx-2 select-primary col-12" appearance="fill">
                        <mat-label>{{ 'generic.therapy-type' | translate }}</mat-label>
                        <mat-select name="task_therapy_type_{{task.id}}" [(ngModel)]="task.customs.therapy_type" required>
                          @for (option of therapy_options; track option) {
                            <mat-option [value]="option.value">{{ option.label }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                  }
                  <mat-form-field class="ml-2 input-primary col-12" *appHideIfOrganization="'alexion,enel'">
                    <input matInput name="task_description_{{task.id}}"
                      placeholder="{{'generic.description' | translate}}" [(ngModel)]="task.description"
                      [readonly]="!task.editMode" required>
                  </mat-form-field>
                  @if (currentOrganization?.customs?.profile == 'enel') {
                    <mat-form-field class="pb-2 select-primary col-12" appearance="fill"
                      >
                      <mat-label>{{ 'pages.task-management.component.description' | translate }}</mat-label>
                      <mat-select name="task_description_select_{{task.id}}" class="color-default"
                        [(ngModel)]="task.description" [disabled]="!task.editMode" required>
                        @for (sec of allSections; track sec) {
                          <mat-option [value]="sec">{{ sec }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                  @if (currentOrganization?.customs?.profile == 'enel') {
                    <mat-form-field class="pb-2 select-primary col-12" appearance="fill"
                      >
                      <mat-label>{{ 'pages.task-management.component.itemid' | translate }}</mat-label>
                      <mat-select name="task_item_id_{{task.id}}" class="color-default" [(ngModel)]="task.item_id"
                        [disabled]="!task.editMode" [required]="task.additional_text == 'level project'">
                        <mat-option></mat-option>
                        @for (itid of filerItemBySection(task.description); track itid) {
                          <mat-option [value]="itid.id">{{ itid.text
                            }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                  @if (!isAlexion() || (isAlexion() && task.additional_text === 'therapy')) {
                    <mat-form-field class="mx-2 input-primary col-12" appearance="fill"
                      >
                      <mat-label>{{ 'pages.task-management.component.action' | translate }}</mat-label>
                      <textarea matInput name="task_action_{{task.id}}" [(ngModel)]="task.action"
                      [readonly]="!task.editMode" required></textarea>
                    </mat-form-field>
                  }
                  @if (isAlexion()) {
                    <mat-form-field class="mx-2 input-primary col-12 my-2" appearance="fill">
                      <textarea matInput name="task_note_{{task.id}}" placeholder="{{'generic.note' | translate}}"
                      [(ngModel)]="task.customs.note" [readonly]="!task.editMode"></textarea>
                    </mat-form-field>
                  } @else {
                    <mat-form-field class="mx-2 input-primary col-4 my-2">
                      <input matInput name="task_assigned_{{task.id}}"
                        placeholder="{{'pages.task-management.component.responsible' | translate}}"
                        [(ngModel)]="task.assigned_user_name" [readonly]="!task.editMode">
                    </mat-form-field>
                  }
                  @if (isAlexion() && task.additional_text === 'visit') {
                    <mat-form-field class="datepicker-primary col-4" appearance="fill" (click)="visit_date.open()">
                      <mat-label>{{ 'pages.task-management.component.visit-date' | translate }}</mat-label>
                      <input matInput [matDatepicker]="visit_date" [readonly]="!task.editMode"
                        [(ngModel)]="task.customs.visit_date" class="color-default ng-trim-ignore" disabled>
                      <mat-datepicker-toggle matSuffix [for]="visit_date">
                        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #visit_date [disabled]="!task.editMode"></mat-datepicker>
                    </mat-form-field>
                  }
                  @if (!isAlexion() || (isAlexion() && task.additional_text === 'therapy')) {
                    @if (currentOrganization?.customs?.profile != 'enel') {
                      <mat-form-field class="datepicker-primary col-4" appearance="fill" (click)="start_date.open()"
                        >
                        <mat-label>{{ 'pages.task-management.component.start-date' | translate }}</mat-label>
                        <input matInput [matDatepicker]="start_date" [readonly]="!task.editMode"
                          [(ngModel)]="task.start_date" class="color-default ng-trim-ignore" disabled>
                        <mat-datepicker-toggle matSuffix [for]="start_date">
                          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #start_date [disabled]="!task.editMode"></mat-datepicker>
                      </mat-form-field>
                    }
                    @if (isAlexion() && task.id && !task.editMode && !task.end_date) {
                      <span class="label-box font-weight-bold ml-5 pl-5">In corso</span>
                    } @else {
                      <mat-form-field class="datepicker-primary col-4" appearance="fill" (click)="end_date.open()">
                        <mat-label>{{ 'pages.task-management.component.end-date' | translate }}</mat-label>
                        <input matInput [matDatepicker]="end_date" [readonly]="!task.editMode" [(ngModel)]="task.end_date"
                          class="color-default ng-trim-ignore" disabled>
                        <mat-datepicker-toggle matSuffix [for]="end_date">
                          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #end_date [disabled]="!task.editMode"></mat-datepicker>
                      </mat-form-field>
                    }
                  }
                  <!-- <mat-checkbox class="abs-tr" name="check_completed_{{i}}" [checked]="task.has_completed == true" [disabled]="true" ></mat-checkbox> -->
                  @if (!task.editMode) {
                    <div class="row mx-auto flex-row-reverse">
                      <button mat-icon-button class="mr-2" color="warn" [disableRipple]="true" (click)="deleteTask(task)"
                        matTooltip="{{'tooltip.delete' | translate}}" [matTooltipPosition]="'above'">
                        <fa-icon [icon]="faTrash"></fa-icon>
                      </button>
                      <button mat-icon-button [disableRipple]="true" (click)="modifyTask(task, true)"
                        matTooltip="{{'tooltip.edit' | translate}}" [matTooltipPosition]="'above'"><i
                      class="icon-edit main-color"></i></button>
                      <ng-container *appHideIfOrganization="'alexion'">
                        @if (task.has_completed == true) {
                          <button mat-stroked-button
                            class="rounded-pill border-success text-success" (click)="checkCompletedTask(task, false)">
                            <fa-icon [icon]="faCheck"></fa-icon>
                            {{ 'generic.done' | translate }}
                          </button>
                        }
                        @if (task.has_completed == false) {
                          <button mat-stroked-button class="rounded-pill"
                            (click)="checkCompletedTask(task, true)">
                            <fa-icon [icon]="faCheck"></fa-icon>
                            {{ 'generic.not-done' | translate }}
                          </button>
                        }
                      </ng-container>
                    </div>
                  }
                  @if (task.editMode) {
                    <div class="row mx-auto flex-row-reverse">
                      @if (task.id) {
                        <button matButton="filled" color="primary" class="mr-2"
                          (click)="modifyTask(task, false)">{{ 'generic.buttons.update' | translate }}
                        </button>
                      }
                      @if (!task.id) {
                        <button matButton="filled" color="primary" class="mr-2"
                          (click)="saveNewTask(task)">{{ 'generic.buttons.save' | translate }}
                        </button>
                      }
                      @if (!task.id || task.editMode) {
                        <button matButton="filled" color="warn" class="mr-2"
                          (click)="cancelEditing(task)">{{ 'generic.buttons.cancel-and-back' | translate }}
                        </button>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        }

        <!-- <div class="row justify-content-center mb-3">
        <button matButton="filled" color="primary">{{'pages.task-management.component.action-complete-start-table' | translate}}</button>
      </div> -->


    </mat-expansion-panel>

  </mat-accordion>
</div>
</div>

<!-- Progress bar -->
<!-- <div class="row">
<h2>Inserire la timeline dinamica</h2>
</div> -->

<!-- Blocco 2 -->
<div class="container-fluid accordion-container">
  <div class="container">
    <mat-accordion class="accordion" multi>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span class="index">2 </span>
            @if (isAlexion()) {
              <span><span>{{ 'generic.visits' | translate }}</span></span>
            } @else {
              <span>{{ 'pages.task-management.component.ended-actions' | translate }}</span>
            }
          </mat-panel-title>
        </mat-expansion-panel-header>

        @if (!isAlexion()) {
          @for (task of taskCompleted; track task; let i = $index) {
            @if (task.show && task.show == true) {
              <div class="row">
                <div class="col-12 px-2">
                  <div class="box px-0 box-two-row py-3">
                    @if (!task.editMode) {
                      <mat-label class="box-title px-3">
                        @if (isAlexion()) {
                          {{ "pages.task-management." + task.additional_text | translate}}
                          @if (task.additional_text == 'therapy') {
                            - {{ "pages.task-management." + task.customs.therapy_type | translate}}
                          } @else {
                            - {{ "generic.session" | translate}} {{ task.customs.session.evaluation_session }}
                          }
                        } @else {
                          {{ task.additional_text }}
                        }
                      </mat-label>
                    }
                    @if (task.editMode) {
                      <mat-form-field class="pb-2 mx-2 select-primary col-12" appearance="fill">
                        @if (!isAlexion()) {
                          <mat-label>{{ 'generic.level' | translate }}</mat-label>
                        }
                        @if (isAlexion()) {
                          <mat-label>{{ 'generic.type' | translate }}</mat-label>
                        }
                        <mat-select name="task_additional_text_{{task.id}}" [(ngModel)]="task.additional_text" required>
                          @for (option of additional_text_options; track option) {
                            <mat-option [value]="option.value">{{ option.label
                              }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                    @if (isAlexion() && task.additional_text === 'visit') {
                      @if (task.editMode) {
                        <mat-form-field class="pb-2 mx-2 select-primary col-12" appearance="fill">
                          <mat-label>{{ 'generic.session' | translate }}</mat-label>
                          <mat-select name="task_session_{{task.id}}" [(ngModel)]="task.customs.session" required>
                            @for (option of sessions_option; track option) {
                              <mat-option [value]="option.value">{{ option.label }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                    }
                    @if (isAlexion() && task.additional_text === 'therapy') {
                      @if (task.editMode) {
                        <mat-form-field class="pb-2 mx-2 select-primary col-12" appearance="fill">
                          <mat-label>{{ 'generic.therapy-type' | translate }}</mat-label>
                          <mat-select name="task_therapy_type_{{task.id}}" [(ngModel)]="task.customs.therapy_type" required>
                            @for (option of therapy_options; track option) {
                              <mat-option [value]="option.value">{{ option.label }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                    }
                    <mat-form-field class="ml-2 input-primary col-12" *appHideIfOrganization="'alexion,enel'">
                      <input matInput placeholder="{{'generic.description' | translate}}" [(ngModel)]="task.description"
                        [readonly]="!task.editMode" required>
                    </mat-form-field>
                    @if (currentOrganization?.customs?.profile == 'enel') {
                      <mat-form-field class="pb-2 select-primary col-12" appearance="fill"
                        >
                        <mat-label>{{ 'pages.task-management.component.description' | translate }}</mat-label>
                        <mat-select name="task_description_select_{{task.id}}" class="color-default"
                          [(ngModel)]="task.description" [disabled]="!task.editMode" required>
                          @for (sec of allSections; track sec) {
                            <mat-option [value]="sec">{{ sec }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                    @if (currentOrganization?.customs?.profile == 'enel') {
                      <mat-form-field class="pb-2 select-primary col-12" appearance="fill"
                        >
                        <mat-label>{{ 'pages.task-management.component.itemid' | translate }}</mat-label>
                        <mat-select name="task_item_id_{{task.id}}" class="color-default" [(ngModel)]="task.item_id"
                          [disabled]="!task.editMode" [required]="task.additional_text == 'level project'">
                          <mat-option></mat-option>
                          @for (itid of filerItemBySection(task.description); track itid) {
                            <mat-option [value]="itid.id">{{
                              itid.text }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                    @if (!isAlexion() || (isAlexion() && task.additional_text === 'therapy')) {
                      <mat-form-field class="mx-2 input-primary col-12" appearance="fill"
                        >
                        <mat-label>{{ 'pages.task-management.component.action' | translate }}</mat-label>
                        <textarea matInput name="task_action_{{task.id}}" [(ngModel)]="task.action"
                        [readonly]="!task.editMode" required></textarea>
                      </mat-form-field>
                    }
                    @if (isAlexion()) {
                      <mat-form-field class="mx-2 input-primary col-12 my-2" appearance="fill">
                        <textarea matInput name="task_note_{{task.id}}" placeholder="{{'generic.note' | translate}}"
                        [(ngModel)]="task.customs.note" [readonly]="!task.editMode"></textarea>
                      </mat-form-field>
                    } @else {
                      <mat-form-field class="mx-2 input-primary col-4 my-2">
                        <input matInput placeholder="{{'pages.task-management.component.responsible' | translate}}"
                          [(ngModel)]="task.assigned_user_name" [readonly]="!task.editMode">
                      </mat-form-field>
                    }
                    @if (isAlexion() && task.additional_text === 'visit') {
                      <mat-form-field class="datepicker-primary col-4" appearance="fill" (click)="visit_date.open()">
                        <mat-label>{{ 'pages.task-management.component.visit-date' | translate }}</mat-label>
                        <input matInput [matDatepicker]="visit_date" [readonly]="!task.editMode"
                          [(ngModel)]="task.customs.visit_date" class="color-default ng-trim-ignore" disabled>
                        <mat-datepicker-toggle matSuffix [for]="visit_date">
                          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #visit_date [disabled]="!task.editMode"></mat-datepicker>
                      </mat-form-field>
                    }
                    @if (!isAlexion() || (isAlexion() && task.additional_text === 'therapy')) {
                      @if (currentOrganization?.customs?.profile != 'enel') {
                        <mat-form-field class="datepicker-primary col-4" appearance="fill" (click)="start_date.open()"
                          >
                          <mat-label>{{ 'pages.task-management.component.start-date' | translate }}</mat-label>
                          <input matInput [matDatepicker]="start_date" [readonly]="!task.editMode"
                            [(ngModel)]="task.start_date" class="color-default ng-trim-ignore" disabled>
                          <mat-datepicker-toggle matSuffix [for]="start_date">
                            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                          </mat-datepicker-toggle>
                          <mat-datepicker #start_date [disabled]="!task.editMode"></mat-datepicker>
                        </mat-form-field>
                      }
                      <mat-form-field class="datepicker-primary col-4" appearance="fill" (click)="end_date.open()">
                        <mat-label>{{ 'pages.task-management.component.end-date' | translate }}</mat-label>
                        <input matInput [matDatepicker]="end_date" [readonly]="!task.editMode" [(ngModel)]="task.end_date"
                          class="color-default ng-trim-ignore" disabled>
                        <mat-datepicker-toggle matSuffix [for]="end_date">
                          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #end_date [disabled]="!task.editMode"></mat-datepicker>
                      </mat-form-field>
                    }
                    <div class="row mx-auto flex-row-reverse">
                      <button mat-icon-button class="mr-2" color="warn" [disableRipple]="true" (click)="deleteTask(task)"
                        matTooltip="{{'tooltip.delete' | translate}}" [matTooltipPosition]="'above'">
                        <fa-icon [icon]="faTrash"></fa-icon>
                      </button>
                      <button mat-stroked-button class="rounded-pill border-success text-success"
                        (click)="checkCompletedTask(task, false)">
                        <fa-icon [icon]="faCheck"></fa-icon>
                        Completato
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            }
          }
        } @else {
          @for (task of visits; track task; let i = $index) {
            @if (task.show && task.show == true) {
              <div class="row">
                <div class="col-12 px-2">
                  <div class="box px-0 box-two-row py-3" [class]="task.editMode == true ? 'border-modify': ''">
                    @if (!task.editMode) {
                      <mat-label class="box-title px-3">
                        @if (isAlexion()) {
                          {{ "pages.task-management." + task.additional_text | translate}}
                          @if (task.additional_text == 'therapy') {
                            - {{ "pages.task-management." + task.customs.therapy_type | translate}}
                          } @else {
                            - {{ "generic.session" | translate}} {{ task.customs.session.evaluation_session }}
                          }
                        } @else {
                          {{ task.additional_text }}
                        }
                      </mat-label>
                    }
                    @if (task.editMode && !isAlexion()) {
                      <mat-form-field class="pb-2 mx-2 select-primary col-12" appearance="fill"
                        >
                        @if (!isAlexion()) {
                          <mat-label>{{ 'generic.level' | translate }}</mat-label>
                        }
                        @if (isAlexion()) {
                          <mat-label>{{ 'generic.type' | translate }}</mat-label>
                        }
                        <mat-select name="task_additional_text_{{task.id}}" [(ngModel)]="task.additional_text" required>
                          @for (option of additional_text_options; track option) {
                            <mat-option [value]="option.value">{{ option.label
                              }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                    <mat-form-field class="ml-2 input-primary col-12" *appHideIfOrganization="'alexion,enel'">
                      <input matInput placeholder="{{'generic.description' | translate}}" [(ngModel)]="task.description"
                        [readonly]="!task.editMode" required>
                    </mat-form-field>
                    @if (currentOrganization?.customs?.profile == 'enel') {
                      <mat-form-field class="pb-2 select-primary col-12" appearance="fill"
                        >
                        <mat-label>{{ 'pages.task-management.component.description' | translate }}</mat-label>
                        <mat-select name="task_description_select_{{task.id}}" class="color-default"
                          [(ngModel)]="task.description" [disabled]="!task.editMode" required>
                          @for (sec of allSections; track sec) {
                            <mat-option [value]="sec">{{ sec }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                    @if (currentOrganization?.customs?.profile == 'enel') {
                      <mat-form-field class="pb-2 select-primary col-12" appearance="fill"
                        >
                        <mat-label>{{ 'pages.task-management.component.itemid' | translate }}</mat-label>
                        <mat-select name="task_item_id_{{task.id}}" class="color-default" [(ngModel)]="task.item_id"
                          [disabled]="!task.editMode" [required]="task.additional_text == 'level project'">
                          <mat-option></mat-option>
                          @for (itid of filerItemBySection(task.description); track itid) {
                            <mat-option [value]="itid.id">{{
                              itid.text }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                    @if (!isAlexion() || (isAlexion() && task.additional_text === 'therapy')) {
                      <mat-form-field class="mx-2 input-primary col-12" appearance="fill"
                        >
                        <mat-label>{{ 'pages.task-management.component.action' | translate }}</mat-label>
                        <textarea matInput name="task_action_{{task.id}}" [(ngModel)]="task.action"
                        [readonly]="!task.editMode" required></textarea>
                      </mat-form-field>
                    }
                    @if (isAlexion()) {
                      <mat-form-field class="mx-2 input-primary col-12 my-2" appearance="fill">
                        <textarea matInput name="task_note_{{task.id}}" placeholder="{{'generic.note' | translate}}"
                        [(ngModel)]="task.customs.note" [readonly]="!task.editMode"></textarea>
                      </mat-form-field>
                    } @else {
                      <mat-form-field class="mx-2 input-primary col-4 my-2">
                        <input matInput placeholder="{{'pages.task-management.component.responsible' | translate}}"
                          [(ngModel)]="task.assigned_user_name" [readonly]="!task.editMode">
                      </mat-form-field>
                    }
                    @if (isAlexion() && task.additional_text === 'visit') {
                      <mat-form-field class="datepicker-primary col-4" appearance="fill" (click)="visit_date.open()">
                        <mat-label>{{ 'pages.task-management.component.visit-date' | translate }}</mat-label>
                        <input matInput [matDatepicker]="visit_date" [readonly]="!task.editMode"
                          [(ngModel)]="task.customs.visit_date" class="color-default ng-trim-ignore" disabled>
                        <mat-datepicker-toggle matSuffix [for]="visit_date">
                          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #visit_date [disabled]="!task.editMode"></mat-datepicker>
                      </mat-form-field>
                    }
                    @if (!isAlexion() || (isAlexion() && task.additional_text === 'therapy')) {
                      @if (currentOrganization?.customs?.profile != 'enel') {
                        <mat-form-field class="datepicker-primary col-4" appearance="fill" (click)="start_date.open()"
                          >
                          <mat-label>{{ 'pages.task-management.component.start-date' | translate }}</mat-label>
                          <input matInput [matDatepicker]="start_date" [readonly]="!task.editMode"
                            [(ngModel)]="task.start_date" class="color-default ng-trim-ignore" disabled>
                          <mat-datepicker-toggle matSuffix [for]="start_date">
                            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                          </mat-datepicker-toggle>
                          <mat-datepicker #start_date [disabled]="!task.editMode"></mat-datepicker>
                        </mat-form-field>
                      }
                      <mat-form-field class="datepicker-primary col-4" appearance="fill" (click)="end_date.open()">
                        <mat-label>{{ 'pages.task-management.component.end-date' | translate }}</mat-label>
                        <input matInput [matDatepicker]="end_date" [readonly]="!task.editMode" [(ngModel)]="task.end_date"
                          class="color-default ng-trim-ignore" disabled>
                        <mat-datepicker-toggle matSuffix [for]="end_date">
                          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #end_date [disabled]="!task.editMode"></mat-datepicker>
                      </mat-form-field>
                    }
                    <!-- <mat-checkbox class="abs-tr" name="check_completed_{{i}}" [checked]="task.has_completed == true" [disabled]="true" ></mat-checkbox> -->
                    @if (!task.editMode) {
                      <div class="row mx-auto flex-row-reverse">
                        @if (!isAlexion()) {
                          <button mat-icon-button class="mr-2" color="warn" [disableRipple]="true"
                            (click)="deleteTask(task)" matTooltip="{{'tooltip.delete' | translate}}"
                            [matTooltipPosition]="'above'">
                            <fa-icon [icon]="faTrash"></fa-icon>
                          </button>
                        }
                        <button mat-icon-button [disableRipple]="true" (click)="modifyTask(task, true)"
                          matTooltip="{{'tooltip.edit' | translate}}" [matTooltipPosition]="'above'"><i
                        class="icon-edit main-color {{ isAlexion() ? 'mr-2' : '' }}"></i></button>
                        <ng-container *appHideIfOrganization="'alexion'">
                          @if (task.has_completed == true) {
                            <button mat-stroked-button
                              class="rounded-pill border-success text-success" (click)="checkCompletedTask(task, false)">
                              <fa-icon [icon]="faCheck"></fa-icon>
                              {{ 'generic.done' | translate }}
                            </button>
                          }
                          @if (task.has_completed == false) {
                            <button mat-stroked-button class="rounded-pill"
                              (click)="checkCompletedTask(task, true)">
                              <fa-icon [icon]="faCheck"></fa-icon>
                              {{ 'generic.not-done' | translate }}
                            </button>
                          }
                        </ng-container>
                      </div>
                    }
                    @if (task.editMode) {
                      <div class="row mx-auto flex-row-reverse">
                        @if (task.id) {
                          <button matButton="filled" color="primary" class="mr-2"
                            (click)="modifyTask(task, false)">{{ 'generic.buttons.update' | translate }}
                          </button>
                        }
                        @if (!task.id) {
                          <button matButton="filled" color="primary" class="mr-2"
                            (click)="saveNewTask(task)">{{ 'generic.buttons.save' | translate }}
                          </button>
                        }
                        @if ((!task.id || task.editMode) && !isAlexion()) {
                          <button matButton="filled" color="warn"
                            class="mr-2" (click)="cancelEditing(task)">{{ 'generic.buttons.cancel-and-back' | translate }}
                          </button>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          }
        }


        <!-- Pulsante di aggiunta Task -->
        <!-- <div class="container" *ngIf="decisionPlan?.id && decisionPlan?.tasks && decisionPlan.tasks.length > 1">
        <div class="row">
          <button class="col-12 big-button" mat-raised-button (click)="addTask()">
            <i class="icon-big_add"></i>
            {{'components.management-plan.add-task' | translate}}
          </button>
        </div>
      </div> -->

    </mat-expansion-panel>
  </mat-accordion>
</div>
</div>


<!-- Buttons -->
<div class="buttons-container container py-4">
  <button class="button-primary float-left" mat-button [disabled]="loading" [routerLink]="['../show']">
    <i class="icon-Backward-arrow-small"></i>
    {{ 'generic.buttons.go-back' | translate }}
  </button>
</div>